import { Alert } from '@/UIComponents2/Alert'
import useResendVerificationEmail from '../services/useResendVerificationEmail'
import { Trans } from 'react-i18next'
import { cn } from '@/utlis/cn'
import { Button } from '@/UIComponents2/Button'

export default function AccountNotVerifiedAlert({
    active,
    additionalClassName,
}: {
    active: boolean
    additionalClassName?: string
}) {
    const { resendVerificationEmail, isVerificationEmailSent, set_isVerificationEmailSent } =
        useResendVerificationEmail()

    return (
        <>
            {active && !isVerificationEmailSent && (
                <Alert className={cn('z-10', additionalClassName)} variant="solid" level="warning">
                    <Trans
                        i18nKey={
                            "Your account isn't verified. To use all of Muse's features, you need to verify your email.<br /> <0>Resend Verification Email<0>"
                        }
                        components={[
                            <Button
                                variant="link-dark"
                                onClick={() => {
                                    if (!resendVerificationEmail.loading) {
                                        set_isVerificationEmailSent(true)
                                        resendVerificationEmail.mutate({})
                                    }
                                }}
                            />,
                        ]}
                    />
                </Alert>
            )}
            {!resendVerificationEmail.error && isVerificationEmailSent && (
                <Alert className={cn('z-10', additionalClassName)} variant="solid" level="success">
                    Verification email sent! Check your email inbox and spam folder for the link.
                </Alert>
            )}
            {resendVerificationEmail.error && (
                <Alert className={cn('z-10', additionalClassName)} variant="solid" level="danger">
                    There was a problem sending the verification email. Please check your internet connection and
                    contact support.
                </Alert>
            )}
        </>
    )
}
